import styles from './CategoryChip.module.css'

type Tone = 'order' | 'dividend' | 'board' | 'risk' | 'navy' | 'bonus' | 'split' | 'neutral'

/** Normalized categories from the classifier → label + DESIGN_SPEC chip colours. */
export const CATEGORIES: Record<string, { label: string; tone: Tone }> = {
  order_win: { label: 'Order win', tone: 'order' },
  dividend: { label: 'Dividend', tone: 'dividend' },
  board_meeting: { label: 'Board meeting', tone: 'board' },
  credit_rating: { label: 'Credit rating', tone: 'risk' },
  management_change: { label: 'Mgmt change', tone: 'risk' },
  fund_raising: { label: 'Fund raising', tone: 'navy' },
  capacity_expansion: { label: 'Capacity', tone: 'navy' },
  bonus: { label: 'Bonus', tone: 'bonus' },
  stock_split: { label: 'Split', tone: 'split' },
  buyback: { label: 'Buyback', tone: 'order' },
  financial_results: { label: 'Results', tone: 'navy' },
  merger_acquisition: { label: 'M&A', tone: 'navy' },
  open_offer: { label: 'Open offer', tone: 'navy' },
  regulatory_approval: { label: 'Approval', tone: 'board' },
  regulatory_warning: { label: 'Regulatory', tone: 'risk' },
  litigation: { label: 'Litigation', tone: 'risk' },
  pledge: { label: 'Pledge', tone: 'risk' },
  insider_trading: { label: 'Insider / SAST', tone: 'board' },
  routine: { label: 'Routine', tone: 'neutral' },
}

export interface CategoryChipProps {
  /** Normalized category slug (e.g. `order_win`). Unknown slugs render neutral. */
  category: string | null
  size?: 'sm' | 'md'
}

function humanize(slug: string): string {
  const s = slug.replace(/_/g, ' ')
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function CategoryChip({ category, size = 'md' }: CategoryChipProps) {
  const def = category ? CATEGORIES[category] : undefined
  const label = def?.label ?? (category ? humanize(category) : 'Unclassified')
  const tone: Tone = def?.tone ?? 'neutral'
  return <span className={`${styles.chip} ${styles[size]} ${styles[tone]}`} data-category={category ?? ''}>{label}</span>
}
